import React, { useState } from 'react';
import { Alert, Modal, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';

function CancelAction({ event, cancelEvent }) {
  const [show, setShow] = useState(false);
  const handleShow = (e) => { e.preventDefault(); setShow(true); }
  const handleClose = () => { setShow(false); }

  return <>
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>Cancel</Tooltip>}
    >
      <button
        title="Cancel"
        onClick={handleShow}
        className="btn btn-outline-primary btn-sm">
        <i className="fas fa-calendar-times" aria-hidden="true"></i>
      </button>
    </OverlayTrigger>

    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Cancel {event.type}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Alert variant='primary'>
          Are you sure you want to cancel this {event.type.toLowerCase()}? The patient will not be able to complete this {event.type.toLowerCase()}. Any associated Forms or Telehealth appointments will be canceled.
        </Alert>

      </Modal.Body>

      <Modal.Footer>
        <Button onClick={cancelEvent} variant="primary">Yes</Button>
        <Button variant="secondary" onClick={handleClose}>No</Button>
      </Modal.Footer>
    </Modal>
  </>
}

export default CancelAction;